import { Alert, Box, Button, Divider, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Typography, useMediaQuery } from '@mui/material'
import axiosInstance from 'custom-axios';
import { useFullPageLoader } from 'hooks/useFullPageLoader';
import React, { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { showConfirmSweetAlert } from 'hooks/useSweetAlert';

const EftInformation = ({
    accountTypeId,
    formAccountData,
    userId,
    setFormAccountData,
    activeAccountStep,
    setActiveAccountStep
}) => {

    const matchesMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [transferDetails, setTransferDetails] = useState(formAccountData.transfer_details);
    const [eEftDetails, setEftDetails] = useState([]);
    const [hideFormData, setHideFormData] = useState(false)
    const [investmentAccountData, setInvestmentAccountData] = useState([])
    // const [selectedBankAccountNumber, setSelectedBankAccountNumber] = useState('');
    // const [filteredAccountDetails, setFilteredAccountDetails] = useState([]); / / for bank account number

    const {
        // register,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useFormContext();

    useEffect(() => {
        setValue('eft_information', eEftDetails);
        // setValue('filtered_account_details', filteredAccountDetails);
    }, [eEftDetails, setValue]);


    const createEmptyEft = () => ({
        eft_information_id: null,
        bank_info_id: null,
        bank_account_number: '',
        bank_name: '',
        bank_transit_number: '',
        bank_institution_number: '',
        eft_investment_account_id: ''
    });


    const fetchBankInfoData = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-bank-info/${userId}`);

            if (response.data.length > 0) {
                setTransferDetails(response.data);
            }

        } catch (error) {
            // console.error(error.message);
        }
    }

    const fetchEftData = async () => {

        try {
            const response = await axiosInstance.get(`api/get-user-eft-info/${userId}`);

            setHideFormData(response.is_applicable)

            const investmentAccounts = response.eft_investment_account_details || [];

            setInvestmentAccountData(investmentAccounts);
            const existingDetails = (response.data || []).map(item => ({
                eft_information_id: item.id,
                bank_info_id: item.bank_info_id || null,
                bank_account_number: item.bank_account_number || '',
                bank_name: item.bank_name || '',
                bank_transit_number: item.bank_transit_number || '',
                bank_institution_number: item.bank_institution_number || '',
                eft_investment_account_id: item.eft_investment_account_id || ''
            }));

            if (existingDetails.length > 0) {
                setEftDetails(existingDetails);

            } else if (investmentAccounts.length > 0) {
                setEftDetails([createEmptyEft()]);

            } else {
                setEftDetails([]);
            }

            /* if (response.data) {
                setEftDetails(response.data);
                setInvestmentAccountData(response.eft_investment_account_details)
                setSelectedBankAccountNumber(response.data[0].bank_account_number);
                setFilteredAccountDetails(response.data);
            } */

        } catch (error) {
            // console.error(error.message);
        }
    }

    const fetchAccountTypeInfoData = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-account-type-info/${userId}`);

            if (response.data) {

                setFormAccountData(prevFormData => ({
                    ...prevFormData,
                    account_transfer: response.data.account_transfer,
                    account_eft: response.data.account_eft,
                    account_pac: response.data.account_pac,
                    account_swp: response.data.account_swp,
                    account_income_sweep: response.data.account_income_sweep,
                }));
            }
        } catch (error) {
            // console.error(error.message);
        }
    }

    // Add new EFT information
    const handleAddEft = () => {

        if (eEftDetails.length >= investmentAccountData.length) {
            toast.error('All eligible investment accounts have been added.');
            return;
        }

        setEftDetails(prev => [
            ...prev,
            createEmptyEft()
        ]);

    };

    const handleInvestmentAccountChange = (index, accountId) => {

        setEftDetails(prev =>
            prev.map((item, i) =>
                i === index
                    ? {
                        ...item,
                        eft_investment_account_id: accountId
                    }
                    : item
            )
        );

    };


    // --------------------------------------------------
    // Get available investment accounts
    // Exclude accounts selected in other EFT forms
    // --------------------------------------------------

    const getAvailableInvestmentAccounts = (currentIndex) => {

        const selectedAccounts = eEftDetails
            .filter((item, index) => index !== currentIndex)
            .map(item =>
                String(item.eft_investment_account_id)
            )
            .filter(Boolean);

        return investmentAccountData.filter(account =>
            !selectedAccounts.includes(String(account.id))
        );

    };

    // Bank account dropdown change
    // --------------------------------------------------

    const handleBankAccountChange = (index, bankAccountNumber) => {

        const selectedBank = transferDetails.find(
            detail =>
                String(detail.bank_account_number) ===
                String(bankAccountNumber)
        );

        if (!selectedBank) return;

        setEftDetails(prev =>
            prev.map((item, i) =>
                i === index
                    ? {
                        ...item,

                        bank_account_number:
                            selectedBank.bank_account_number,

                        bank_name:
                            selectedBank.bank_name,

                        bank_transit_number:
                            selectedBank.bank_transit_number,

                        bank_institution_number:
                            selectedBank.bank_institution_number

                    }
                    : item
            )
        );
    };

    //  delete eft details

    const handleDeleteEft = async (index, eftId) => {

        if (eftId) {
            const result = await showConfirmSweetAlert({
                title: 'Are you sure?',
                text: 'You will not be able to recover this!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!',
            });

            if (result.isConfirmed) {
                showLoader();

                try {
                    const response = await axiosInstance.delete(
                        `api/delete-eft-info/${eftId}`
                    );

                    if (response.status == 200) {
                        toast.success(response.message);
                        fetchAllApi();
                    } else {
                        toast.error(response.message);
                    }
                } catch (error) {
                    toast.error(error.message);
                } finally {
                    hideLoader();
                }
            }
        } else {
            const updatedEftDetails = [...eEftDetails];
            updatedEftDetails.splice(index, 1);
            setEftDetails(updatedEftDetails);
            setValue('eft_information', updatedEftDetails);
        }
    };


    // --------------------------------------------------
    // Update parent form data
    // --------------------------------------------------

    const updateParentFormData = (eftData) => {

        setFormAccountData(prevData => ({
            ...prevData,
            eft_information: eftData
        }));

    };


    // --------------------------------------------------
    // EFT validation
    // --------------------------------------------------

    const validateEftInformation = () => {

        if (!hideFormData) {
            return true;
        }

        if (!investmentAccountData.length) {

            toast.error('No eligible investment accounts found.');

            return false;

        }

        if (!eEftDetails.length) {

            toast.error('Please add EFT information.');

            return false;

        }

        const selectedAccounts = eEftDetails.map(item =>
            String(item.eft_investment_account_id)
        );

        if (selectedAccounts.some(account => !account || account === '')) {

            toast.error('Please select an investment account for each EFT.');

            return false;

        }

        if (new Set(selectedAccounts).size !== selectedAccounts.length) {

            toast.error('Duplicate investment accounts are not allowed.');

            return false;

        }

        if (eEftDetails.some(item => !item.bank_account_number)) {

            toast.error('Please select a bank account for each EFT.');

            return false;

        }

        return true;

    };


    // --------------------------------------------------
    // Common API submission
    // --------------------------------------------------

    const saveEftData = async (goToNextStep = false) => {

        if (!validateEftInformation()) return;

        showLoader();

        const modifiedChildStep = goToNextStep
            ? activeAccountStep + 1
            : activeAccountStep;

        const eftInformation = eEftDetails.map(item => ({
            ...item
        }));

        const submitData = {
            eft_information: eftInformation,
            login_id: formAccountData.login_id,
            accountTypeId: accountTypeId,
            user_id: userId ? userId : 0,
            parent_step: 1,
            child_step: modifiedChildStep

        };

        try {

            updateParentFormData(eftInformation);

            const response = await axiosInstance.post(
                'api/save-user-etf-info',
                submitData
            );

            if (response.status === 200) {

                if (goToNextStep) {
                    setActiveAccountStep(modifiedChildStep);
                } else {
                    toast.success(
                        'EFT information saved successfully.'
                    );
                }

            } else {
                toast.error(
                    response.message || 'Something went wrong.'
                );
            }

        } catch (error) {

            toast.error(
                error?.response?.data?.message ||
                error?.message ||
                'An error occurred while saving EFT information.'
            );

        } finally {

            hideLoader();

        }

    };


    const handleRoleBack = async () => {

        showLoader();
        let endPoint = `api/change-form-step`;

        const submitData = { user_id: userId ? userId : 0, parent_step: 1, child_step: activeAccountStep - 1 }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveAccountStep(activeAccountStep - 1);
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred when navigating back.')
        } finally {
            hideLoader();
        }
    };

    const submitForm = async () => {

        await saveEftData(true);
        /* showLoader();
        setFormAccountData(prevData => ({
            ...prevData,
            eft_information: eEftDetails
        }));

        let endPoint = `api/save-user-etf-info`;

        let modifiedChildStep = activeAccountStep + 1

        const submitData = { ...eEftDetails[0], ...filteredAccountDetails[0], login_id: formAccountData.login_id, accountTypeId: 1, user_id: userId ? userId : 0, parent_step: 1, child_step: modifiedChildStep }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveAccountStep(modifiedChildStep);
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred when submitting the form.')
        } finally {
            hideLoader();
        } */
    }

    const saveEftInformation = async () => {
        await saveEftData(false);
    };

    const canAddEft = eEftDetails.length < investmentAccountData.length;

    const fetchAllApi = async () => {
        try {
            showLoader()
            await fetchBankInfoData()
            await fetchEftData()
            await fetchAccountTypeInfoData()

        } catch (error) {
            // hideLoader()
            toast.error('An error occurred while fetching data.')
        } finally {
            hideLoader();
        }
    }

    useEffect(() => {
        fetchAllApi()
    }, [])


    return (
        <>
            {/* <form onSubmit={handleSubmit(submitForm)}>
                {hideFormData &&
                    <Grid container spacing={2} className='p-4'>

                        <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                            <label htmlFor="swp_account-details" className='font15px'>Select Existing Investment Account</label>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl
                                fullWidth
                                size="small"
                                error={Boolean(errors && errors['eft_investment_account_id '])}
                            >
                                <InputLabel id="select-account-details">Investment Account</InputLabel>
                                <Select
                                    labelId="select-account-details"
                                    label='Investment Account'
                                    value={eEftDetails[0].eft_investment_account_id || ''}
                                    classes={{ select: "custom-select-label" }}
                                    MenuProps={{
                                        disableScrollLock: true,
                                        PaperProps: { sx: { maxHeight: 200 } }
                                    }}
                                    onChange={(e) => {
                                        const updatedBankDetails = [...eEftDetails];
                                        updatedBankDetails[0].eft_investment_account_id = e.target.value;
                                        setEftDetails(updatedBankDetails);
                                    }}
                                    inputProps={register('eft_investment_account_id ', {
                                        required: true
                                    })}
                                >
                                    {investmentAccountData.map((option) => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                        </Grid>
                        <Grid item xs={12} sm={12} md={4}></Grid>


                        <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                            <label htmlFor="bank-name" className='font15px'>Account Number</label>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl
                                fullWidth
                                size="small"
                            >
                                <InputLabel id="select-tpi-instruction_currency">Account Number</InputLabel>
                                <Select
                                    labelId="select-tpi-instruction_currency"
                                    label="Account Number"
                                    value={selectedBankAccountNumber}
                                    classes={{ select: "custom-select-label" }}
                                    name='instruction_currency'
                                    MenuProps={{
                                        disableScrollLock: true,
                                        PaperProps: { sx: { maxHeight: 200 } }
                                    }}
                                    onChange={handleDropdownChange}
                                >
                                    {transferDetails.map((detail) => (
                                        <MenuItem key={detail.id} value={detail.bank_account_number}>
                                            {detail.bank_account_number}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4}></Grid>

                        {filteredAccountDetails?.map((item, index) => {

                            return (
                                <React.Fragment key={index}>
                                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                        <label htmlFor="bank-name" className='font15px'>Name Of Bank</label>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextField
                                            label="Name Of Bank"
                                            fullWidth
                                            InputLabelProps={item.bank_name ? { shrink: true } : {}}
                                            size="small"
                                            name='bank_name'
                                            disabled
                                            value={item.bank_name}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}></Grid>


                                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                        <label htmlFor="bank_transit_number" className='font15px'>Bank Transit Number</label>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextField
                                            label="Bank Transit Number"
                                            fullWidth
                                            size="small"
                                            name='bank_transit_number'
                                            disabled
                                            InputLabelProps={item.bank_transit_number ? { shrink: true } : {}}
                                            value={item.bank_transit_number}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}></Grid>


                                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                        <label htmlFor="bank_institution_number" className='font15px'>Institution Number</label>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>

                                        <TextField
                                            label="Institution Number"
                                            fullWidth
                                            size="small"
                                            name='bank_institution_number'
                                            disabled
                                            InputLabelProps={item.bank_institution_number ? { shrink: true } : {}}
                                            value={item.bank_institution_number}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}></Grid>


                                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                        <label htmlFor="bank-account-number" className='font15px'>Bank Account Number</label>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextField
                                            label="Bank Account Number"
                                            fullWidth
                                            size="small"
                                            name='bank_account_number'
                                            disabled
                                            InputLabelProps={item.bank_account_number ? { shrink: true } : {}}
                                            value={item.bank_account_number}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}></Grid>
                                </React.Fragment>
                            )
                        })}
                    </Grid>
                }


                {!hideFormData &&
                    <div className='container'>
                        <Grid item spacing={2} className='p-4'>
                            <Alert
                                severity='info'
                                className='font14px cursor-pointer'
                            // onClick={handleClickExternalInvestmentOpen}
                            >
                                This client's account(s) are not applicable for Eft.
                            </Alert>
                        </Grid>
                    </div>
                }
                <Grid item xs={12} sm={6} className='pt-3 text-center'>
                    <Button variant='outlined' className='m-3' onClick={handleRoleBack}>
                        Back
                    </Button>
                    <Button
                        type='button'
                        variant='outlined'
                        className='m-3'
                        onClick={saveEftInformation}
                        sx={{ color: '#0dbe0d', borderColor: '#0dbe0d', '&:hover': { borderColor: '#0dbe0d', backgroundColor: 'rgba(13, 190, 13, 0.08)' } }}
                    >
                        Save
                    </Button>
                    <Button variant='contained' className='m-3 raintree-btn-green' type='submit'>
                        Save & Next
                    </Button>
                </Grid>
            </form> */}

            <form onSubmit={handleSubmit(submitForm)}>

                {hideFormData && investmentAccountData.length > 0 && (
                    <>
                        {eEftDetails.map((item, index) => (
                            <React.Fragment key={index}>
                                {/* EFT Section Header */}
                                <Grid
                                    container
                                    spacing={2}
                                    className="p-4"
                                >
                                    {/* <Grid item xs={12}>
                                        <Box display="flex" alignItems="center" justifyContent="space-between">
                                            <Typography fontWeight={600}>
                                                EFT INFORMATION #{index + 1}
                                            </Typography>

                                            <IconButton
                                                color="error"
                                                size="small"
                                                onClick={() => handleDeleteEft(index)}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </Box>
                                    </Grid> */}
                                    {console.log(item)}
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        className='form-head-gray-title'
                                    >

                                        <Grid item>
                                            <Typography component={'h3'}>EFT Information #{index + 1}</Typography>
                                        </Grid>

                                        <Grid item>
                                            <IconButton title='Remove' sx={{ p: "0 10px 0 0" }} disabled={index == 0} onClick={() => handleDeleteEft(index, item.eft_information_id)}>
                                                <DeleteIcon sx={{ color: '#dd4747' }} />
                                            </IconButton>
                                        </Grid>
                                    </Grid>



                                    {/* Investment Account */}

                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        className={`align-content-center ${matchesMD ? '' : 'text-right'
                                            }`}
                                    >
                                        <label className="font15px">
                                            Select Existing Investment Account
                                        </label>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControl
                                            fullWidth
                                            size="small"
                                            error={
                                                Boolean(
                                                    errors?.eft_information
                                                )
                                            }
                                        >
                                            <InputLabel>
                                                Investment Account
                                            </InputLabel>

                                            <Select
                                                label="Investment Account"
                                                value={item.eft_investment_account_id || ''}
                                                classes={{ select: 'custom-select-label' }}
                                                MenuProps={{
                                                    disableScrollLock: true,
                                                    PaperProps: {
                                                        sx: {
                                                            maxHeight: 200
                                                        }
                                                    }
                                                }}
                                                onChange={(e) =>
                                                    handleInvestmentAccountChange(
                                                        index,
                                                        e.target.value
                                                    )
                                                }
                                            >

                                                {getAvailableInvestmentAccounts(
                                                    index
                                                ).map(option => (

                                                    <MenuItem
                                                        key={option.id}
                                                        value={option.id}
                                                    >
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={4} />


                                    {/* Bank Account Number */}

                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        className={`align-content-center ${matchesMD ? '' : 'text-right'
                                            }`}
                                    >
                                        <label className="font15px">
                                            Account Number
                                        </label>

                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControl
                                            fullWidth
                                            size="small"
                                        >
                                            <InputLabel> Account Number </InputLabel>

                                            <Select
                                                label="Account Number"
                                                value={item.bank_account_number || ''}
                                                classes={{ select: 'custom-select-label' }}
                                                MenuProps={{
                                                    disableScrollLock: true,
                                                    PaperProps: {
                                                        sx: {
                                                            maxHeight: 200
                                                        }
                                                    }
                                                }}
                                                onChange={(e) =>
                                                    handleBankAccountChange(
                                                        index,
                                                        e.target.value
                                                    )
                                                }
                                            >

                                                {transferDetails.map(detail => (

                                                    <MenuItem
                                                        key={detail.id}
                                                        value={
                                                            detail.bank_account_number
                                                        }
                                                    >
                                                        {detail.bank_account_number}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={4} />


                                    {/* Bank Details */}

                                    {[
                                        {
                                            label: 'Name Of Bank',
                                            field: 'bank_name'
                                        },
                                        {
                                            label: 'Bank Transit Number',
                                            field: 'bank_transit_number'
                                        },
                                        {
                                            label: 'Institution Number',
                                            field: 'bank_institution_number'
                                        },
                                        {
                                            label: 'Bank Account Number',
                                            field: 'bank_account_number'
                                        }
                                    ].map(field => (

                                        <React.Fragment key={field.field}>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={6}
                                                md={4}
                                                className={`align-content-center ${matchesMD ? '' : 'text-right'
                                                    }`}
                                            >
                                                <label className="font15px">
                                                    {field.label}
                                                </label>
                                            </Grid>

                                            <Grid item xs={12} sm={6} md={4}>
                                                <TextField
                                                    label={field.label}
                                                    fullWidth
                                                    size="small"
                                                    name={field.field}
                                                    disabled
                                                    InputLabelProps={
                                                        item[field.field]
                                                            ? { shrink: true }
                                                            : {}
                                                    }
                                                    value={
                                                        item[field.field] || ''
                                                    }
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={4}
                                            />
                                        </React.Fragment>
                                    ))}
                                </Grid>

                                {index !== eEftDetails.length - 1 && (
                                    <Divider className="my-3" />
                                )}
                            </React.Fragment>

                        ))}


                        {/* Add EFT Information */}

                        {canAddEft && (

                            <Grid
                                container
                                justifyContent="start"
                                className="pb-3 padding-left35px"
                            >
                                <Grid item>
                                    <Button
                                        onClick={handleAddEft}
                                        startIcon={<AddIcon />}
                                    >
                                        Add EFT Information
                                    </Button>
                                </Grid>
                            </Grid>

                        )}

                    </>

                )}


                {/* No EFT Applicable */}

                {!hideFormData && (

                    <div className="container">

                        <Grid
                            container
                            spacing={2}
                            className="p-4"
                        >

                            <Grid item xs={12}>

                                <Alert
                                    severity="info"
                                    className="font14px cursor-pointer"
                                >

                                    This client's account(s) are not applicable for EFT.

                                </Alert>

                            </Grid>

                        </Grid>

                    </div>

                )}


                {/* Action Buttons */}

                <Grid
                    container
                    justifyContent="center"
                    className="pt-3"
                >

                    <Grid item xs={12} className="text-center">

                        <Button
                            variant="outlined"
                            className="m-3"
                            onClick={handleRoleBack}
                            type="button"
                        >

                            Back

                        </Button>


                        <Button
                            type="button"
                            variant="outlined"
                            className="m-3"
                            onClick={saveEftInformation}
                            disabled={!hideFormData}
                            sx={{
                                color: '#0dbe0d',
                                borderColor: '#0dbe0d',
                                '&:hover': {
                                    borderColor: '#0dbe0d',
                                    backgroundColor: 'rgba(13, 190, 13, 0.08)'
                                }
                            }}
                        >

                            Save

                        </Button>


                        <Button
                            variant="contained"
                            className="m-3 raintree-btn-green"
                            type="submit"
                            disabled={!hideFormData}
                        >

                            Save & Next

                        </Button>

                    </Grid>

                </Grid>

            </form>

            {loader}
            <ToastContainer />
        </>
    )
}
export default EftInformation